export const totalQuoteItems = (items: any[] = []): number =>
  items.reduce((total: number, item) => {
    if (item.type === 'section' && Array.isArray(item.children)) {
      return (
        total +
        item.children.filter((child: any) => child.type === 'product').length
      );
    }
    if (item.type === 'product' && !item.parentID) {
      return total + 1;
    }
    return total;
  }, 0);
